/**
 *
 * @module redeemedPasscodeToken
 *
 */

import Token from './../../token/entry';

const IdentityToken = Token.IdentityToken;

/**
 *
 * @class RedeemedPasscodeToken
 * @extends {SDK.Services.Token.IdentityToken}
 *
 */
export default class RedeemedPasscodeToken extends IdentityToken {

    /**
     *
     * @param {String} token
     * @param {Number} expiration
     * @param {String} [reason]
     *
     */
    constructor(token, expiration, reason) {

        super(token, expiration);

        /**
         *
         * @access private
         * @param {String|undefined} reason
         *
         */
        this.reason = reason;

    }

}



// WEBPACK FOOTER //
// ./src/services/identity/bam/redeemedPasscodeToken.js